<!--vr场景-->
<template>
  <!-- start VR层 -->
  <section class="vrbox">
    <div id="pano" class="img-placeholder" style="width: 100%; height: 100%; float: right">
      <noscript
        ><table style="width: 100%; height: 100%">
          <tr style="vertical-align: middle">
            <td>
              <div style="text-align: center">
                ERROR:<br /><br />Javascript not activated<br /><br />
              </div>
            </td>
          </tr></table
      ></noscript>
    </div>
  </section>
  <!-- end VR层 -->
</template>
<script>
import { mapGetters } from 'vuex';
import config from '@/config/index';
import util from '@/utils/util';
import { createPanoComponent } from '@/services/krpano/panoFactory';
// import { Kankan4D } from '@/services/krpano/kankan4d';
import panoTypes from '@/services/panoTypes';

export default {
  inject: ['panoPromise'],
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo',
    }),
    dealerId() {
      return this.baseInfo.dealerId;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initPano();
    });
  },
  methods: {
    initPano() {
      if (util.supportWebGL && !util.browser.isIE) {
        const datetime = Math.floor(new Date().getTime() / (1000 * 300));
        const fdRight = this.baseInfo.fdRight;
        let panoType = panoTypes.krpanpo;
        if (fdRight.hasRights && fdRight.hasPublish && fdRight.sceneId) {
          panoType = panoTypes.fourKankan;
        }
        const initSettings = {
          panoType: panoType,
          publishVersion: SCRIPT_VER,
          xmlUrl: `${config.dealerCloudVrapi}/vrapi/tour/config?dealerId=${this.dealerId}&scriptId=${SCRIPT_VER}&_=${datetime}`,
          dealerId: this.dealerId,
          cityId: this.baseInfo.cityId,
          source: this.baseInfo.source,
          sceneId: fdRight.sceneId,
        };
        const pano = createPanoComponent(initSettings);
        pano.readyPromise.then(() => {
          if (!IS_LOCAL) {
            document.domain = 'autohome.com.cn';
          }
        });
        this.panoPromise.resolve(pano);
      }
    },
  },
};
</script>
<style lang="scss">
.vrbox {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  img {
    /*width:100%;
		height:100%;*/
  }
}
</style>
